export class CreateGaleryImageModel {
    public venueId: string;
    public Attachments: any;
  }